// import "firebase/auth";
// import { getAuth } from "firebase/auth";
import * as React from "react";
import AuthCheckLoading from "./AuthCheckLoading";
import Redirect from "./Redirect";
// function AuthCheckRedirectSignIn(props: { children: React.ReactNode }) {
//   const auth = getAuth();
//   return (
//     <AuthCheckLoading
//       fallback={<Redirect to="/login/signIn" is_return={true}></Redirect>}
//       // requiredClaims={{ policy_agreed: true }}
//     >
//       {/* {policyAgreed == null && <div>isLoading</div>}
//       {policyAgreed == false && (
//         <div>
//           {fallback ? fallback : <Redirect to="/login/signIn"></Redirect>}
//         </div>
//       )}
//       {policyAgreed == true && <div>{props.children}</div>} */}
//       {props.children}
//     </AuthCheckLoading>
//   );
// }

export default function AuthCheckRedirect(props: {
  children: React.ReactNode;
}) {
  return (
    <AuthCheckLoading
      fallback={<Redirect to="/login/signIn" is_return={true}></Redirect>}
      // loadingNode={<div>loading</div>}
    >
      {props.children}
    </AuthCheckLoading>
  );
}
